var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99991 7.49999H10.0082M8.63574 2.99249L1.88074 14.2708C1.74149 14.512 1.6678 14.7854 1.667 15.0639C1.6662 15.3423 1.73832 15.6162 1.87619 15.8581C2.01407 16.1001 2.21288 16.3017 2.45286 16.443C2.69284 16.5842 2.96562 16.6602 3.24407 16.6633H16.7557C17.0341 16.6601 17.3067 16.5841 17.5466 16.4429C17.7864 16.3017 17.9852 16.1001 18.123 15.8583C18.2609 15.6165 18.333 15.3428 18.3323 15.0645C18.3316 14.7861 18.2581 14.5128 18.1191 14.2717L11.3641 2.99166C11.222 2.75708 11.0217 2.56311 10.7828 2.42849C10.5438 2.29387 10.2742 2.22314 9.99991 2.22314C9.72563 2.22314 9.45599 2.29387 9.21703 2.42849C8.97807 2.56311 8.77786 2.75708 8.63574 2.99166V2.99249Z",
    stroke: "#156083",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 10H9.99984V13.3333H10.8332",
    stroke: "#156083",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.adb9bd9e47b4722f8a9e08212734909e.svg";
export { ForwardRef as ReactComponent };